import { useState, useEffect } from 'react'
import { fetchPosts, type GhostPost } from '../ghost'

interface UseGhostPostsResult {
	posts: GhostPost[]
	loading: boolean
	error: string | null
}

export function useGhostPosts(limit = 3): UseGhostPostsResult {
	const [posts, setPosts] = useState<GhostPost[]>([])
	const [loading, setLoading] = useState(true)
	const [error, setError] = useState<string | null>(null)

	useEffect(() => {
		fetchPosts(limit)
			.then((data) => {
				setPosts(data)
				setLoading(false)
			})
			.catch((err: Error) => {
				setError(err.message)
				setLoading(false)
			})
	}, [limit])

	return { posts, loading, error }
}
